import route from '../ziggy/route'

export default {
    methods: { route }
}
